<script lang="ts">
  import { onMount } from "svelte";
  import { loop, onDestroy, trusted } from "svelte/internal";

  let base: HTMLDivElement;
  let block: HTMLDivElement;

  let baseRect: DOMRect = {} as any;
  let blockHeight: number;

  let stay = true;
  function render() {
    blockHeight = block.offsetHeight;

    var rect = base.getBoundingClientRect();
    var baseTop = rect.top;

    var blockBottom = window.innerHeight - (baseTop + blockHeight);

    stay = blockBottom >= 0;
  }

  // loop render becasue to react to svelte animations etc..
  const task = loop(() => {
    render();
    return true;
  });

  onMount(render);
  onDestroy(() => task.abort());

  function resizeWatcher(node: HTMLElement, handler: (node: HTMLElement) => void) {
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) if (entry.target === node) handler(node);
    });
    resizeObserver.observe(node);
    return {
      destroy() {
        resizeObserver.unobserve(node);
      },
    };
  }
</script>

<svelte:window on:scroll={render} />

<div use:resizeWatcher={(e) => (baseRect = e.getBoundingClientRect())} bind:this={base} style:height={`${blockHeight}px`}>
  <div use:resizeWatcher={(e) => (blockHeight = e.offsetHeight)} bind:this={block} style:padding-right={!stay ? `${window.innerWidth - baseRect.width - baseRect.left}px` : null} style:padding-left={!stay ? `${baseRect.left}px` : null} class="sticky-bottom" class:stay>
    <slot />
  </div>
</div>

<style lang="scss">
  .sticky-bottom {
    background: #fff;
    padding: 20px 0;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
    z-index: 10;

    &.stay {
      position: static;
      box-shadow: none;
      background: transparent;
    }
  }
</style>
